// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import * as Tone from "tone";
import type { ReactNode } from "react";
import {
  Children,
  cloneElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useStore } from "@hmpu/powerups.store";
import { useTranslate } from "@hmpu/powerups.intl.legacy.hooks.use-translate";
import { useTranslation } from "@hmpu/powerups.intl.hooks.use-translation";
import { useViewport } from "@hmpu/powerups.hooks.use-viewport";
import { PageTitleAnnouncer } from "@hmpu/powerups.ui.page-title-announcer";
import { NavBar } from "@hmpu/powerups.ui.nav-bar";
import { SettingsDialog } from "../settings";
import { isInPortrait } from "@hmpu/powerups.utils.screen-info";
import { HiddenH1 } from "@hmpu/powerups.ui.a11y.hidden-h1";
import { usePageConfig } from "@hmpu/powerups.config.page.provider";
import SkipButton from "../SkipButton/SkipButton";
import PauseButton from "../PauseButton/PauseButton";
import OrientationChangeReminder from "../OrientationChangeReminder/OrientationChangeReminder";
import VIE from "../Templates/VIE";
import { getDisabledPageIDs } from "../../hooks/usePauseScreenDisabled";

import "./GameWrapper.css";
import { PauseGeneral } from "../../pages/Pause/PauseGeneral";
import GAME_PAGES from "../../constants/GAME_PAGES";
import { usePageNavigation } from "../../hooks/usePageNavigation";
import AudioDescriptions from "../Accessibility/AudioDescriptions";

export type GameWrapperProps = {
  children: ReactNode;
};

export const GameWrapper = (props: GameWrapperProps) => {
  const debugGameWrapper = false;
  // window.store2 = {};

  const translate = useTranslate();
  const bgImg = translate('bgImg', 'DISCLAIMER');
  // @ts-ignore
  document.querySelector('body').style.backgroundImage = `url(${bgImg})`;
  const inPortrait = useStore((state) => state.inPortrait);
  const setInPortrait = useStore((state) => state.setInPortrait);
  const play = useStore((state) => state.play);
  const setPlay = useStore(useCallback((state) => state.setPlay, []));
  // const setPlay = useStore((state) => state.setPlay);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const isPauseMenuDisplayed = useStore((state) => state.isPauseMenuDisplayed);
  const isPauseInterrupterDisplayed = useStore((state) => state.isPauseInterrupterDisplayed);
  const setIsPauseInterrupterDisplayed = useStore((state) => state.setIsPauseInterrupterDisplayed);
  const setIsPauseEnabled = useStore((state) => state.setIsPauseEnabled);
  const setUserId = useStore((state) => state.setUserId);
  const page = useStore((state) => state.currentPage);
  const setIsPauseBtnDisplayed = useStore(
    (state) => state.setIsPauseBtnDisplayed
  );
  const currentVIEConfig = useStore((state) => state.currentVIEConfig);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const playerConfig = translate("VIE"); // { state.setSkipTarget }
  const currentCueRef = useRef("");
  const toyOnScreenLayout = useStore((state) => state.toyOnScreenLayout);
  const setToyOnScreenLayout = useStore((state) => state.setToyOnScreenLayout);
  const setIsPauseMenuDisplayed = useStore(
    useCallback((state) => state.setIsPauseMenuDisplayed, [])
  );
  const parentNodeSplash = "SPLASH";
  const { __t } = useTranslation(parentNodeSplash);

  useEffect(() => {
    console.log("-----------------pagekey--------------- " + pageKey);
  }, []);

  useEffect(() => {
    if (isPauseEnabled) {
      //@ts-ignore
      AudioDescriptions.speechMethod.cancel();
    } else {
      //@ts-ignore
      AudioDescriptions.speechMethod.resume();
    }
  }, [isPauseEnabled]);

  // create css vars from json

  useEffect(() => {
    // alert();
    console.log(translate("THEME")); //.vars_colors

    const colors = translate("system", "THEME");

    const theme = document.createElement("style");
    document.head.appendChild(theme);

    colors.forEach((colorObj: any) => {
      const colorKey = Object.keys(colorObj)[0];
      const colorValue = colorObj[colorKey];
      const variableName = `--${colorKey}`;
      const rule = `:root { ${variableName}: ${colorValue}; }`;
      // console.log('theme: rules: ', rule);
      // @ts-ignore
      theme.sheet.insertRule(rule);

      // const themeMapped = translate('mapped','THEME');
      // themeMapped.forEach((colorRef) => {
      //   const colorKey = Object.keys(colorObj)[0];
      //   const colorValue = colorObj[colorKey];
      //   const variableName = `--${colorKey}`;
      //   const rule = `:root { ${variableName}: ${colorValue}; }`;
      //   console.log('theme: rules: ', rule);
      //   theme.sheet.insertRule(rule);
    });

    // const theme = document.createElement('style');
    // document.head.appendChild(theme);

    // // @ts-ignore
    // Object.entries(colors).forEach(([category, categoryColors]) => {
    //   // @ts-ignore
    //   const rules = categoryColors.map((colorObj) => {
    //     const colorKey = Object.keys(colorObj)[0];
    //     const colorValue = colorObj[colorKey];

    //     return `--${colorKey}: ${colorValue};`;
    //   }).join(' ');

    //   const rule = `:root { ${rules} }`;
    //   console.log('theme: rule: ', rule);
    //   // @ts-ignore
    //   theme.sheet.insertRule(rule);
    // });
  }, []);

  const pgLogoAlt = __t("pgLogoAlt");
  // @2DO: const pgLogoImg = globalizedMedia(translate('pgLogoImg', parentNodeSplash), 'img');
  const pgLogoImg = "";

  // const pgLogoAlt = __t('pgLogoAlt');
  // const pgLogoImg = globalizedMedia(translate('pgLogoImg', parentNodeSplash), 'img');

  const currentCueMetadata = useStore((state) => state.currentCueMetadata);
  const [showPGwarning, setShowPGwarning] = useState(false);
  const settingsPanelData = "SETTINGS_PANEL";

  useEffect(() => {
    if (isPauseMenuDisplayed) {
      // hide the Pause button when PauseMenu is displayed
      setIsPauseBtnDisplayed(false);
    }
  }, [isPauseMenuDisplayed, setIsPauseBtnDisplayed]);

  // adding aria-labels for volume buttons
  useEffect(() => {
    const waitToFindButtons = 10;
    setTimeout(() => {
      const volumeDownButton = document.querySelector(".volume-down");
      const volumeUpButton = document.querySelector(".volume-up");

      if (volumeDownButton) {
        volumeDownButton.setAttribute(
          "aria-label",
          __t("volumeDown", settingsPanelData)
        );
      }

      if (volumeUpButton) {
        volumeUpButton.setAttribute(
          "aria-label",
          __t("volumeUp", settingsPanelData)
        );
      }
    }, waitToFindButtons);
  }, [showSettingsPanel]);

  // check if toy is on screen
  const navElement = document.querySelector("nav");
  const pauseAndSkipButtons = document.querySelector(".nav-bar div");
  const body = document.querySelector("body");

  useEffect(() => {
    if (page === GAME_PAGES.DISCLAIMER || page === GAME_PAGES.SPLASH || page === GAME_PAGES.ONBOARDING) {
      setToyOnScreenLayout(false);
      body?.setAttribute("data-layout", "default");
      navElement?.classList.remove("middle-positioned");
      pauseAndSkipButtons?.classList.add("showNavAtTop");
      pauseAndSkipButtons?.removeAttribute("id");
    } else {
      setToyOnScreenLayout(true);
      body?.setAttribute("data-layout", "toy-on-screen");
      navElement?.classList.add("middle-positioned");
      pauseAndSkipButtons?.classList.remove("showNavAtTop");
      pauseAndSkipButtons?.removeAttribute("id");
    }
  }, [page, showSettingsPanel, isPauseEnabled, inPortrait]);

  useEffect(() => {
    if (currentCueMetadata?.id == "IDLE_LOOP") {
      setShowPGwarning(true);
    } else {
      setShowPGwarning(false);
    }

    if(page === GAME_PAGES.ONBOARDING)  {
      if (currentCueMetadata?.id === "TRIGGER_CONTENT_IN" || currentCueMetadata?.id === "CHAPTER_HOLD") {
        setToyOnScreenLayout(true);
        body?.setAttribute("data-layout", "toy-on-screen");
        pauseAndSkipButtons?.classList.remove("showNavAtTop");
        navElement?.classList.add("middle-positioned");
      }
    }
  }, [currentCueMetadata, page, isPauseEnabled, showSettingsPanel]);

  // hotfixing axe issue: Axe shows duplicate id issue when settings panel is opened and closed until a test is re-performed)
  useEffect(() => {
    const settingsPanelToggle = document.querySelector(
      "#SettingsPanel-Toggler"
    );

    if (settingsPanelToggle) {
      const newId = document.querySelector(".pause-general")
        ? "SettingsPanel-Toggler-Pause"
        : "";

      settingsPanelToggle.setAttribute("id", newId);
    }
  }, [showSettingsPanel, isPauseEnabled]);

  useEffect(() => {
    const buttons = document.querySelectorAll('.cta-btn');
    buttons.forEach(button => {
      const span = button.querySelector('span');
      if (span) {
        span.setAttribute('data-text', span.textContent || '');
      }
    });
  }, [page, isPauseEnabled, inPortrait, showSettingsPanel, currentCueMetadata?.id]);

  const [isNavBarTopPositioned, setIsNavBarTopPositioned] = useState(true);

  // console.log('currentVIEConfig', currentVIEConfig);

  // initialize viewport hook
  const viewport = useViewport();

  // const {
  //   goToPage,
  //   goToNextPage,
  //   goToPrevPage
  // } = useVieConfig();

  // const {
  //   pagesMap,
  //   getPageKey
  // } = usePageConfig();

  // const pageKey = getPageKey(page);
  // const pageConfig = translate(pageKey);

  const { goToPage, goToNextPage, goToPrevPage } = usePageNavigation();

  const { pagesMap, getPageKey, getPageId } = usePageConfig();

  const pageKey = getPageKey(page);

  const documentVisibilityState = useStore(
    (state) => state.documentVisibilityState
  );
  const setDocumentVisibilityState = useStore(
    useCallback((state) => state.setDocumentVisibilityState, [])
  );

  const pauseScreenDisabledPagesID = useCallback(
    () =>
      getDisabledPageIDs(__t("disablePauseScreenOn", "PAUSE_MENU"), getPageId),
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    []
  )();

  let children = Children.toArray(props.children);
  const parentNode = "INTERRUPTER_ORIENTATION";
  const interrupterOrientationCopy = translate(parentNode);
  const parentNodePause = "PAUSE_MENU";

  const interrupterPauseCopy = translate(parentNodePause);

  const byLine = translate("text", "BYLINE");

  const pauseScreenDisabledPages = interrupterPauseCopy.disablePauseScreenOn;
  // const pauseScreenDisabledPagesID = [];

  // (pauseScreenDisabledPages && pauseScreenDisabledPages.length > 0) && (
  // pauseScreenDisabledPages.forEach((pageName) => {
  //   if (pageName === 'DISCLAIMER') {
  //     pauseScreenDisabledPagesID.push(parseInt(0));
  //   } else if (pageName === 'SPLASH') {
  //     pauseScreenDisabledPagesID.push(parseInt(1));
  //   } else if (pageName === 'CAMERA_ACCESS') {
  //     pauseScreenDisabledPagesID.push(parseInt(2));
  //   } else if (pageName === 'TOY_SCAN') {
  //     pauseScreenDisabledPagesID.push(parseInt(3));
  //   } else if (pageName === 'CHARACTER_SELECTION') {
  //     pauseScreenDisabledPagesID.push(parseInt(4));
  //   } else if (pageName === 'GAME_PLAY') {
  //     pauseScreenDisabledPagesID.push(parseInt(5));
  //   } else if (pageName === 'END_GAME') {
  //     pauseScreenDisabledPagesID.push(parseInt(6));
  //   }
  // }));

  // in use to show interrupter on orientation change (based on json)
  const [captureLockOrientation, setCaptureLockOrientation] = useState();
  const [orientationFetched, setOrientationFetched] = useState(false);

  // in use for showing pause screen on interrupter unmount
  const [isInterrupterMounted, setIsInterrupterMounted] = useState(true);

  const tabBack = () => {
    setIsVisible(false);
    setIsPauseEnabled(false);
    setIsPauseMenuDisplayed(false);
  };

  useEffect(() => {
    console.log("IS PAUSE ENABLED : " + isPauseEnabled);
    console.log("IS PAUSE MENU DISPLAYED : " + isPauseMenuDisplayed);
  }, [isPauseMenuDisplayed, isPauseEnabled]);


  // useResetFocus([showSettingsPanel, inPortrait, isPauseEnabled]);

  // const orientationHandler = useCallback(
  //   (evt) => {
  //     const portraitMode = isInPortrait();
  //     setInPortrait(portraitMode);

  //     //Pause all video
  //     if (!portraitMode) {
  //       //debugger;
  //       setPlay(false);
  //     } else {
  //       if (!showSettingsPanel && !isPauseEnabled) {
  //         // when Settings Panel is not open & video is not previously paused
  //         setPlay(true);
  //       }
  //     }
  //   },
  //   [setPlay, setInPortrait, showSettingsPanel, isPauseEnabled]
  // );
  const alertMountedWarning = () => {
    // console.log(
    //   'alertMountedWarning :: pauseScreenDisabledPagesID',
    //   pauseScreenDisabledPagesID
    // );
    if (!pauseScreenDisabledPagesID.includes(page)) {
      // setIsInterrupterMounted(true);
    }
  };

  const isPortaitWidth = () => {
    const clientWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    const clientHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    debugGameWrapper &&
      console.log(
        "CLIENT WIDTH: ",
        clientWidth,
        "CLIENT HEIGHT: ",
        clientHeight
      );
    const iOSPortait = clientHeight > clientWidth;
    return iOSPortait;
  };
  debugGameWrapper && console.log("IS IOS PORTAIT:", isPortaitWidth());

  const orientationHandler = useCallback(
    () => {
      const portraitMode = isInPortrait();
      // update the store if the orientation has changed
      // if (inPortrait !== portraitMode) {
      setInPortrait(portraitMode);
      // }
      //Pause all video
      if (!portraitMode && play) {
        //debugger;
        setPlay(false);
      } else {
        if (!showSettingsPanel && !isPauseEnabled) {
          // when Settings Panel is not open & video is not previously paused
          setPlay(true);
        }
      }
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [page, showSettingsPanel, isPauseEnabled]
  );

  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === 'hidden') {
      setIsPauseInterrupterDisplayed(true);
      setIsPauseEnabled(true);
    }
  }, [setIsPauseInterrupterDisplayed, setIsPauseEnabled]);

  /* const { audioCtxState } = useReactAudioContext();
  *const handleVisibilityChange = useCallback(() => {
     // const audioCtxState = Tone.getContext().state;
     const audioCtxSuspended = audioCtxState === "suspended";
     if (document.visibilityState === "hidden") {
       //debugger;
       setPlay(false);
       if (audioCtxSuspended) return;
       Tone.Transport.pause();
     } else {
       if (!showSettingsPanel && !isPauseEnabled && isInPortrait()) {
         // when Settings Panel is not open & video is not previously paused
         setPlay(true);
         if (audioCtxSuspended) return;
         Tone.Transport.start();
       }
     }
   }, [setPlay, showSettingsPanel, isPauseEnabled]);*/

  useEffect(() => {
    (isPauseEnabled || isPauseInterrupterDisplayed || isPauseMenuDisplayed) ? AudioDescriptions.cancel() : AudioDescriptions.resume();
  }, [isPauseEnabled, isPauseInterrupterDisplayed, isPauseMenuDisplayed]);

  useEffect(() => {
    window.addEventListener("resize", orientationHandler);
    let hasChangeListener = false;
    if (window.screen.hasOwnProperty("orientation")) {
      hasChangeListener = true;
      window.screen.orientation.addEventListener("change", orientationHandler);
    }
    setInPortrait(isInPortrait());

    return () => {
      window.removeEventListener("resize", orientationHandler);
      if (hasChangeListener) {
        window.screen.orientation.removeEventListener(
          "change",
          orientationHandler
        );
      }
    };
  }, [orientationHandler, handleVisibilityChange, setInPortrait]);

  useEffect(() => {
    window.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      window.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  const prevPagePauseScreenDisabledRef = useRef(
    pauseScreenDisabledPagesID.includes(page)
  );

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleVisChgPauseMenu = () => {
      const currPagePauseScreenDisabled =
        pauseScreenDisabledPagesID.includes(page);
      if (
        document.visibilityState === documentVisibilityState &&
        currPagePauseScreenDisabled !== prevPagePauseScreenDisabledRef.current
      )
        return; // nothing to do
      if (document.visibilityState === "visible") {
        if (!pauseScreenDisabledPagesID.includes(page)) {
          setIsPauseEnabled(true);
          setPlay(false);
          document
            .querySelectorAll("video")
            .forEach((player) => player.pause());
        }
      }
      // else {
      //   setIsPauseMenuDisplayed(false);
      // }
    };

    document.addEventListener("visibilitychange", handleVisChgPauseMenu);

    return () => {
      document.removeEventListener("visibilitychange", handleVisChgPauseMenu);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [page]);
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === 'visible') {
  //       if (!pauseScreenDisabledPagesID.includes(page)) {
  //         setIsVisible(true);
  //         setIsPauseEnabled(true);
  //         setPlay(false);
  //       }
  //     } else {
  //       setIsVisible(false);
  //       window.dispatchEvent(
  //         new CustomEvent('pausePC', {
  //           detail: {
  //             showPauseButton: false,
  //             isPauseEnabled: true,
  //           },
  //         })
  //       );
  //     }
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);
  // useEffect(() => {
  //   orientationHandler();
  //   handleVisibilityChange();
  // }, [orientationHandler, handleVisibilityChange]);

  useEffect(() => {
    setUserId(new URLSearchParams(window.location.search).get("userId"));
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  //hotfix for focus indicator outline when VO is on (iPhone)
 useEffect(() => {
  setTimeout(() => {
    const buttonElement = document.getElementById('SettingsPanel-Toggler');
    if (buttonElement) {
      const attrsToRemove = ['aria-haspopup'];
      attrsToRemove.forEach(attr => {
        buttonElement.removeAttribute(attr);
      });    }
  }, 200); 
}, [page, showSettingsPanel, isPauseEnabled, inPortrait]);

  useEffect(() => { 
    if (isPauseMenuDisplayed) {
      // hide the Pause button when PauseMenu is displayed
      setIsPauseBtnDisplayed(false);
    }
  }, [isPauseMenuDisplayed, setIsPauseBtnDisplayed]);

  /*useEffect(() => {
    if (isPauseEnabled) {
      //@ts-ignore
      AudioDescriptions.speechMethod.pause();
    } else {
      //@ts-ignore
      AudioDescriptions.speechMethod.resume();
    }
  }, [isPauseEnabled]);*/

  const mainContentHidden = !inPortrait || showSettingsPanel;
  useEffect(() => {
    document.body.classList.add(`market--${__t("market", "GENERAL")}`);
  }, []);

  // console.log("currentVIEConfig", currentVIEConfig);

  return (
    <>
      <main
        className={`game-wrapper ${pageKey} market--${__t(
          "market",
          "GENERAL"
        )} ${currentCueRef.current}`}
        key={"game-wrapper"}
        style={
          {
            backgroundImage: `url(${bgImg})`,
            // height: `${viewport.height}px`,
          }
        }
        // aria-hidden={isPauseMenuDisplayed || !inPortrait ? 'true' : 'false'}
      >
        <PageTitleAnnouncer />
        {inPortrait && (
          <NavBar
            hidden={mainContentHidden}
            slotConfig={{
              root: (
                <>
                  <SettingsDialog />
                </>
              ),
              row: (
                <>
                  {/* {!isPauseEnabled && !page === pagesMap.SPLASH && ( */}
                  <HiddenH1 />
                  {/* )} */}
                  {/* <BackButton onClick={(evt) => goToPrevPage()} /> */}
                  <PauseButton />
                  <SkipButton />
                </>
              ),
            }}
          />
        )}
        <div
          className="gamewrapper-inner"
          hidden={mainContentHidden}
          aria-hidden={mainContentHidden}
          style={{
            // height: "100%",
            // width: "100%",
            // display: mainContentHidden ? "none" : "block",
          }}
          tab-index={mainContentHidden ? "-1" : "0"}
        >
          {/* {!mainContentHidden && !isPauseEnabled && props.children} */}
          <div
            id="Page-Wrapper"
            style={{
              height: "100%",
              width: "100%",
              display: isPauseEnabled ? "none" : "block",
              position: "absolute",
            }}
          >
            {props.children}
          </div>

          <VIE
            InterfaceVideo={(currentVIEConfig?.video.length > 1) ? currentVIEConfig?.video[1] : currentVIEConfig?.video[0]}
            ToyVideo={currentVIEConfig?.toyVideo}
            Metadata={currentVIEConfig?.metadata}
            Captions={currentVIEConfig?.captions}
            Descriptions={currentVIEConfig?.descriptions}
            TextOverlays={currentVIEConfig?.legal}
            Templates={currentVIEConfig?.templates}
            PlayerConfig={playerConfig}
            Overlays={currentVIEConfig?.overlays}
            onEnded={currentVIEConfig?.onEnded || null}
            chapterOverride={currentVIEConfig?.skipChapter}
            setBeatsList={currentVIEConfig?.setBeatsList}
            Poster={currentVIEConfig?.Poster}
            hide={currentVIEConfig?.hide}
            onNextPage={() => goToNextPage()}
            onPrevPage={() => goToPrevPage()}
            onGoToPage={(v: string | number) => goToPage(v)}
            onCueChange={(v: any) => {
              console.log("VIE.onCueChange", v);
              currentCueRef.current = v[0].id;
            }}
          />
          {/* {
            (page === GAME_PAGES.DISCLAIMER) && (

              <div className="copyright-text">
                {showPGwarning && (
                <div className="pg-logo-wrapper">
                  <img src={pgLogoImg} alt={pgLogoAlt} className="splash-logo-img" />
                </div>
              )}
              <span>{byLine}</span>
            </div>
            )
          } */}
        </div>

        <div className="options-btn-grad">
          <svg
            width="120"
            height="120"
            viewBox="0 0 125 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={true}
          >
            <defs>
              <linearGradient
                id="svgBtnStroke"
                gradientUnits="objectBoundingBox"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="0%" stopColor="#FCE685" />
                <stop offset="20%" stopColor="#EBB261" />
                <stop offset="50%" stopColor="#FEF08B" />
                <stop offset="80%" stopColor="#EAAA56" />
                <stop offset="100%" stopColor="#F1B02D" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        {inPortrait && isPauseEnabled && !showSettingsPanel && (
          <PauseGeneral tabBack={tabBack} />
        )}
        {/* {orientationFetched && captureLockOrientation !== inPortrait && (
          <OrientationChangeReminder
            alertMountedWarning={alertMountedWarning}
            alertUnMountedWarning={alertMountedWarning}
            setIsVisible={setIsVisible}
          />
        )} */}
        {!inPortrait && (
          <OrientationChangeReminder
            alertMountedWarning={alertMountedWarning}
            alertUnMountedWarning={alertMountedWarning}
          />
        )}
        {/* {<TestingNav
          pageIndex={page}
          pagesMap={pagesMap}
          goToPrevPage={goToPrevPage}
          goToNextPage={goToNextPage}
        />} */}
        {/* <LanguageSwitcher hidden={mainContentHidden} aria-hidden={true} /> */}
      </main>
    </>
  );
};

export default GameWrapper;
